import { IStore } from 'store/types';
import { ICalculatorRules } from 'types';

export const selectCalculatorRules =
  () =>
  (state: IStore): ICalculatorRules =>
    state?.calculatorRules;
